import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import useMagnetic from '../hooks/useMagnetic'

export default function Login() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [time, setTime] = useState('')
  const [bootDone, setBootDone] = useState(false)
  const executeBtnRef = useMagnetic()

  useEffect(() => {
    const t = setInterval(() => setTime(new Date().toTimeString().slice(0, 8)), 1000)
    setTime(new Date().toTimeString().slice(0, 8))
    setTimeout(() => setBootDone(true), 1200)
    return () => clearInterval(t)
  }, [])

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) { setError(error.message); setLoading(false); return }
    navigate('/dashboard')
    setLoading(false)
  }

  return (
    <div style={{ background: '#000', minHeight: '100vh', color: '#ff0055', fontFamily: "'Share Tech Mono', monospace", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20, position: 'relative', overflow: 'hidden' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Share+Tech+Mono&family=Bebas+Neue&family=Space+Grotesk:wght@700;800&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        .scanlines{position:fixed;inset:0;background:repeating-linear-gradient(0deg,transparent,transparent 2px,rgba(0,0,0,0.08) 2px,rgba(0,0,0,0.08) 3px);pointer-events:none;z-index:100}
        .grid-bg{position:fixed;inset:0;background-image:linear-gradient(rgba(255,0,80,0.025) 1px,transparent 1px),linear-gradient(90deg,rgba(255,0,80,0.025) 1px,transparent 1px);background-size:28px 28px;pointer-events:none;z-index:0}
        .t-input{width:100%;background:transparent;border:none;border-bottom:1px solid rgba(255,0,80,0.3);color:#ff0055;font-family:'Share Tech Mono',monospace;font-size:14px;padding:12px 0;outline:none;transition:border-color 0.2s}
        .t-input:focus{border-color:#ff0055}
        .t-input::placeholder{color:rgba(255,0,80,0.3)}
        .t-btn{width:100%;background:#ff0055;color:#000;border:none;padding:18px;font-family:'Share Tech Mono',monospace;font-size:13px;letter-spacing:2px;cursor:pointer;transition:all 0.2s;margin-top:28px;font-weight:700}
        .t-btn:hover{background:#fff;box-shadow:0 0 30px rgba(255,0,80,0.4)}
        .t-btn:disabled{opacity:0.5;cursor:not-allowed}
        @keyframes bootIn{from{opacity:0;transform:translateX(-6px)}to{opacity:1;transform:translateX(0)}}
      `}</style>
      <div className="scanlines" />
      <div className="grid-bg" />

      <div style={{ width: '100%', maxWidth: 440, position: 'relative', zIndex: 2 }}>
        {/* TOP BAR */}
        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,0,80,0.2)', paddingBottom: 12, marginBottom: 20, fontSize: 10, letterSpacing: 2 }}>
          <span style={{ color: 'rgba(255,0,80,0.8)' }}>2DOLLARSITES EXCHANGE</span>
          <span style={{ color: 'rgba(255,0,80,0.6)' }}>{time}</span>
        </div>

        {/* BOOT */}
        <div style={{ marginBottom: 24, fontSize: 10, lineHeight: 1.8 }}>
          <div style={{ color: '#ff0055', animation: 'bootIn 0.3s ease 0.1s both' }}>&gt; MEMBER_AUTH SYSTEM ACTIVE...</div>
          <div style={{ color: 'rgba(255,0,80,0.65)', animation: 'bootIn 0.3s ease 0.4s both' }}>&gt; Verifying exchange credentials........... [OK]</div>
          <div style={{ color: 'rgba(255,0,80,0.65)', animation: 'bootIn 0.3s ease 0.7s both' }}>&gt; Loading member portfolio................. [OK]</div>
          <div style={{ color: '#ff0055', animation: 'bootIn 0.3s ease 1.0s both' }}>&gt; READY — AUTHENTICATE TO ENTER</div>
        </div>

        {/* RED LINE */}
        <div style={{ height: 1, background: 'linear-gradient(90deg, #ff0055, transparent)', marginBottom: 28, boxShadow: '0 0 8px rgba(255,0,80,0.3)' }} />

        {/* TITLE */}
        <div style={{ opacity: bootDone ? 1 : 0, transform: bootDone ? 'translateY(0)' : 'translateY(8px)', transition: 'all 0.5s ease', marginBottom: 28 }}>
          <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 56, color: '#ff0055', letterSpacing: -2, lineHeight: 1, marginBottom: 6, textShadow: '0 0 30px rgba(255,0,80,0.3)' }}>
            MEMBER_LOGIN
          </div>
          <div style={{ fontSize: 11, color: 'rgba(255,0,80,0.7)', letterSpacing: 2 }}>
            WELCOME BACK · MARKET OPEN 24/7
          </div>
        </div>

        {/* FORM */}
        <form onSubmit={handleLogin} style={{ opacity: bootDone ? 1 : 0, transition: 'opacity 0.5s ease 0.2s' }}>
          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 9, letterSpacing: 2, color: 'rgba(255,0,80,0.7)', marginBottom: 10 }}>// EMAIL_ADDRESS</div>
            <input className="t-input" type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div>
            <div style={{ fontSize: 9, letterSpacing: 2, color: 'rgba(255,0,80,0.7)', marginBottom: 10 }}>// PASSWORD</div>
            <input className="t-input" type="password" placeholder="your password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>

          {error && (
            <div style={{ fontSize: 11, color: '#ff0055', border: '1px solid rgba(255,0,80,0.4)', padding: '10px 14px', marginTop: 16, letterSpacing: 0.5 }}>
              ✗ AUTH_ERROR: {error}
            </div>
          )}

          <button type="submit" ref={executeBtnRef} className="t-btn" disabled={loading}>
            {loading ? '> AUTHENTICATING...' : '▶ EXECUTE — SIGN IN'}
          </button>
        </form>

        <div style={{ marginTop: 24, borderTop: '1px solid rgba(255,0,80,0.1)', paddingTop: 16, fontSize: 11, color: 'rgba(255,0,80,0.6)', letterSpacing: 1, textAlign: 'center' }}>
          NO_ACCOUNT?{' '}
          <Link to="/signup" style={{ color: '#ff0055', textDecoration: 'none', fontWeight: 700 }}>JOIN FOR $2/MONTH →</Link>
        </div>

        <div style={{ marginTop: 28, display: 'flex', justifyContent: 'space-between', fontSize: 8, color: 'rgba(255,0,80,0.3)', letterSpacing: 1 }}>
          <span>2DOLLARSITES.COM</span>
          <span>MARKET OPEN 24/7</span>
          <span>EST.2026</span>
        </div>
      </div>
    </div>
  )
}
